// extracted by mini-css-extract-plugin
module.exports = {"iconStyle":"icon__iconStyle___1DdHG","iconStyleInactive":"icon__iconStyleInactive___dPlKL"};